/* eslint-disable react/no-children-prop */
import React, { useState } from 'react'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'

import { RadioButton } from '@components/atoms'
import {
	CheckmarkCircle12Regular,
	ChevronDown20Regular,
	ChevronUp20Regular,
	DismissCircle20Regular,
} from '@fluentui/react-icons'
import { RadioGroup } from '@headlessui/react'
import { ResultSimulateQuestionType } from '@models/simulated.model'
import rehypeRaw from 'rehype-raw'

import { questionStyles } from './styles'

const {
	Container,
	containerQuestion,
	headerQuestion,
	DescriptionQuestion,
	containerDesc,
	numberContainer,
	radioGroup,
	feedbackContainer,
	spaceContainer,
	ButtonOpen,
	IconStatus,
	DivStatus,
} = questionStyles

interface QuestionProps {
	value: ResultSimulateQuestionType
	index?: string | number
}

export const QuestionSimulateResult = ({
	value,
	index,

	...props
}: QuestionProps) => {
	const [open, setOpen] = useState<boolean>(false)

	return (
		<Container>
			<div className={headerQuestion()}>
				<div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
					<div className={numberContainer()}>{index}</div>
					<div className={containerDesc()}>
						<h6>{value?.title}</h6>
					</div>
				</div>

				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						width: '234.5px',
						alignItems: 'center',
					}}
				>
					{value.isCorrect === true && (
						<DivStatus status>
							<p>Acertou</p>
							<IconStatus>
								<CheckmarkCircle12Regular />
							</IconStatus>
						</DivStatus>
					)}
					{value.isCorrect === false && (
						<DivStatus status={value.isCorrect}>
							<p>Errou</p>
							<IconStatus>
								<DismissCircle20Regular />
							</IconStatus>
						</DivStatus>
					)}
					{value.isCorrect === null && (
						<DivStatus status={value.isCorrect}>
							<p>Não respondeu</p>
						</DivStatus>
					)}

					<ButtonOpen
						type='button'
						onClick={() => {
							setOpen(!open)
						}}
						open={open}
					>
						{open ? <ChevronUp20Regular /> : <ChevronDown20Regular />}
					</ButtonOpen>
				</div>
			</div>

			<DescriptionQuestion
				open={open}
				dangerouslySetInnerHTML={{ __html: value?.description || '' }}
			/>

			{open && (
				<>
					<div className={containerQuestion()} {...props} />

					{value.isCorrect !== null && (
						<RadioGroup
							value={Boolean(value.clientResponse)}
							className={radioGroup()}
							disabled
						>
							<RadioGroup.Option value>
								{({ checked }) => (
									<RadioButton
										questionType
										checked={checked}
										questionAnswer
										isCorrect={value.isCorrect}
									/>
								)}
							</RadioGroup.Option>
							<RadioGroup.Option value={false}>
								{({ checked }) => (
									<RadioButton
										questionType={false}
										checked={checked}
										questionAnswer
										isCorrect={value.isCorrect}
									/>
								)}
							</RadioGroup.Option>
						</RadioGroup>
					)}

					{value.isCorrect === null && (
						<RadioGroup className={radioGroup()} disabled>
							<RadioGroup.Option value>
								{({ checked }) => (
									<RadioButton
										questionType
										checked={checked}
										questionAnswer
										isCorrect={value.isCorrect}
									/>
								)}
							</RadioGroup.Option>
							<RadioGroup.Option value={false}>
								{({ checked }) => (
									<RadioButton
										questionType={false}
										checked={checked}
										questionAnswer
										isCorrect={value.isCorrect}
									/>
								)}
							</RadioGroup.Option>
						</RadioGroup>
					)}

					{value.isCorrect === null && <div className={spaceContainer()} />}

					{value.isCorrect !== null && (
						<div className={feedbackContainer()}>
							<ReactMarkdown
								rehypePlugins={[rehypeRaw]}
								children={value?.answerHtml || ''}
							/>
						</div>
					)}
				</>
			)}
		</Container>
	)
}
